const getEndpointUuid = (type, connectionId, fromToUuid) => {
    return `${type}_${connectionId}_${fromToUuid}`;
};

const createGetEndpointFuncForType = (type) => {
    return (connectionId, fromToUuid) => {
        return getEndpointUuid(type, connectionId, fromToUuid);
    };
};

const getBrickEndpointUuid = createGetEndpointFuncForType('brick');
const getCircleEndpointUuid = createGetEndpointFuncForType('circle');

export default {
    methods: {
        getBrickEndpointUuid,
        getCircleEndpointUuid,
        deconstructEndpointUuid(uuid){
            const [type, connectionId, fromToUuid] = uuid.split('_');

            return {
                type: type,
                connectionId: connectionId,
                fromToId: fromToUuid
            };
        }
    }
};